// extracted by mini-css-extract-plugin
module.exports = {"gradientText":"MainTitle_gradientText__taBaD"};